import { useTranslations } from '~i18n/hooks';
import { abbreviateNumber } from '~utils/number';

import type { BotStatistics } from '../types';

const minimalExactValue = 1000;

export const useFormatBotStatistics = (
	statistic: BotStatistics = { userCount: 0, botCount: 0 },
	full?: boolean
) => {
	const t = useTranslations('BotActions');
	const number = statistic.userCount + statistic.botCount;

	const displayNumber =
		number < 100
			? '100'
			: number < 500
			? '500'
			: number < 1000
			? abbreviateNumber(1000)
			: abbreviateNumber(number);
	let label = displayNumber;

	if (number < minimalExactValue) {
		label = t('messagesLessThanCount', { count: label });
	}

	if (full) {
		label = t('totalMessagesCount', { count: label });
	}

	return label;
};
